import React, {useState, useEffect} from "react";
import EchoButton from "pages/landing-page/items/echo-button/echo-button";
import LaptopImage from "../../assets/images/laptop.png";
import SocialNetBlock from "pages/landing-page/items/socnet_blocks/socnet-block";
import s from "./main.module.scss"

const Main = (props) => {

    const [isShowLocation, setIsShowLocation] = useState(false);
    const [isShowInstagram,  setIsShowInstagram] = useState(false);
    const [isShowTelegram, setIsShowTelegram] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsShowLocation(!isShowLocation);
                setTimeout(() => {setIsShowInstagram(!isShowInstagram)}, 300);
                setTimeout(() => {setIsShowTelegram(!isShowTelegram)}, 600);
            setIsShowTelegram(!isShowTelegram);
        }, 3200);
        return () => {clearInterval(interval)}; 
        
    })

    const showDemoModal = (isShow) => {
        props.setShowDemo()
    }

    const goToAbout = () => {
        const el = document.getElementById('about-product');
        if(el)
            el.scrollIntoView({ block: 'end', inline: "nearest", behavior: "smooth" });
    }

    return (
        <div className={s.Main}>
            <div className={s.mainTextBlock}>
                <div className={s.mainTopTextBlock}>
                    <span>ECHO ANALYTICS</span>
                </div>
                <div className={s.mainText}>
                    {props.selectedLanguage !== 'KAZ' ? <span>{ props.getValue('MONITORING') } </span> : null}
                    <span className={s.greenText}>{ props.getValue('MEDIA_SOCIAL_BLOGS') } </span>
                    <span>{ props.getValue('REVIEWS_ON') } </span>
                    <span className={s.greenText}>{ props.getValue('ONLINE_MAPS') }</span>
                    {props.selectedLanguage === 'KAZ' ? <span>{ props.getValue('MONITORING') } </span> : null}
                </div>
                <div className={s.mainBottomText}>
                    <span>{props.getValue('TRACK_MEMORIES')}</span>
                    <span>{props.getValue('MONITORING_FAVOURITVE_SOCIAL')}</span>
                </div>
            </div>
            <div className={s.mainButtonsBlock}>
                <EchoButton title={props.getValue('GET_DEMO_ACCESS')} callback={showDemoModal}/>
                <button onClick={goToAbout} className={s.getMoreButton}>{props.getValue('GET_MORE')}</button>
                {/*<EchoButton title={props.getValue('GET_MORE')} textStyles={{color: "#13BDE3"}} styleClass={"hoverClass"} styles={{background: 'none', border: '1px solid #13BDE3'}} callback={goToAbout}/>*/}
            </div>
            <div className={s.imageBlock}>
                { isShowLocation ? <SocialNetBlock getValue={props.getValue} name={'LOCATION'} styles={{left: '-120px', top: '70px'}}/> : null }
                { isShowTelegram ? <SocialNetBlock getValue={props.getValue} name={'TELEGRAM'} styles={{right: '-50px', top: '60px'}}/> : null }
                { isShowInstagram ? <SocialNetBlock getValue={props.getValue} name={'INSTAGRAM'} styles={{right: '-50px', top: '250px'}}/> : null}
                <img src={LaptopImage} />
            </div>
        </div>
    )
}

export default Main